import * as V from '../constants/variables';
import * as T from '../constants/types';
import { allLayersGroups } from '../constants/layers';

const processLayers = userGroups => allLayersGroups
    .filter(({ availableFor = [] }) => availableFor.some(group => userGroups.includes(group)))
    .map(({ layers, ...layerGroupInfo }) => {
        return {
            ...layerGroupInfo,
            layers: layers.filter(({ availableFor = [] }) => Array.isArray(availableFor) && availableFor.some(group => userGroups.includes(group))
            ),
        };
    });
// Updated setLayers to accept multiple groups
const setLayers = userGroups => ({
    type: T.SET_LAYERS,
    payload: { layers: processLayers(userGroups) },
});

export const setLayersAccordingToUserGroup = () => (dispatch, getState) => {
    const { loggedUser: { groups } } = getState();

    if (groups.includes(V.SUPER_ADMIN)) {
        return dispatch(setLayers([ V.ADMIN, V.SUPER_ADMIN ]));
    }
    if (groups.includes(V.ADMIN)) return dispatch(setLayers([ V.ADMIN ]));
    if (groups.includes(V.DESIGNER)) return dispatch(setLayers([ V.DESIGNER ]));
    if (!groups.length || groups.includes(V.GUEST)) return dispatch(setLayers([ V.GUEST ]));
};
